export default __webpack_public_path__ + "static/SRUS P239 - Product Specifications & Technical Data-dd7d7c7597a05cea4d99ed61c08869be.pdf";